import React from 'react';
import { useLocation } from 'react-router';
import { HeaderMfe } from '|/app/header';
import VehicleHeader from '|/app/header/purchase-header/treatment/vehicle-confirmation-header';
import SlateHeader from '|/app/header/slate-header';
import { useBrand } from '|/brand';
import { isCarvanaNativeApp } from '|/helpers/is-native-app';
import { isResolverRoute } from '|/helpers/is-resolver-route';

const VehicleRouteHeader = () => {
  const { brand } = useBrand();
  const { pathname } = useLocation();
  const isNative = isCarvanaNativeApp();

  // `/vehicle/{id}` only redirects, and it is the iOS full-purchase-webview entry point — a
  // header painted here flashes for the whole getSummary round trip. TXCC-9813.
  if (isNative && isResolverRoute(pathname)) return null;

  if (brand === 'slate') return <SlateHeader />;
  return isNative ? <VehicleHeader /> : <HeaderMfe orderSummary={null} />;
};

export default VehicleRouteHeader;
